import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { Heart, Info, HelpCircle, Newspaper } from 'lucide-react'
import { PiDotsThreeCircleVertical } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import BlogPage from '@/pages/BlogPage'

const optionsLinks = [
  {
    href: '/favorites',
    labelKey: 'my-favorites',
    icon: Heart,
    color: 'text-redpink',
  },
  {
    href: '/blog',
    labelKey: 'blog',
    icon: Newspaper,
    color: 'text-redpink',
  },
  {
    href: '/help',
    labelKey: 'help',
    icon: HelpCircle,
    color: 'text-blue-500',
  },
  {
    href: '/contact',
    labelKey: 'contact',
    icon: Info,
    color: 'text-whatsapp',
  },
]

export default function MenuOptions() {
  const { t } = useTranslation()

  return (
    <Menu as='div' className='relative inline-block text-left'>
      <Menu.Button className='inline-flex w-full hover:text-redpink items-center justify-center rounded-md text-3xl font-base text-white shadow-sm focus:outline-none transition-all duration-200'>
        <PiDotsThreeCircleVertical className='relative cursor-pointer' />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none divide-y divide-gray-100'>
          <div className='px-1 py-1'>
            {optionsLinks.map(link => {
              const Icon = link.icon

              return (
                <Menu.Item key={link.href}>
                  {({ active }) => (
                    <Link
                      to={link.href}
                      className={`${
                        active ? 'bg-grisclair' : ''
                      } group flex w-full items-center rounded-md px-3 py-2 text-sm transition-all duration-200`}
                    >
                      <Icon
                        className={`mr-3 h-5 w-5 ${link.color}`}
                        aria-hidden='true'
                      />
                      <span
                        className={`${
                          active ? 'text-gray-900' : 'text-gray-700'
                        }`}
                      >
                        {t(link.labelKey)}
                      </span>
                    </Link>
                  )}
                </Menu.Item>
              )
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
